import { render, staticRenderFns } from "./MapControls.vue?vue&type=template&id=23896f88&scoped=true"
import script from "./MapControls.vue?vue&type=script&lang=js"
export * from "./MapControls.vue?vue&type=script&lang=js"
import style0 from "./MapControls.vue?vue&type=style&index=0&id=23896f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23896f88",
  null
  
)

export default component.exports